import React, { useState, useRef, useMemo, useEffect } from 'react';
import { Switch, Route, Redirect, useHistory,useLocation } from 'react-router-dom';
import { Layout, Menu, Spin } from '@arco-design/web-react';
import cs from 'classnames';
import {
  IconDashboard,
  IconTag,
  IconMenuFold,
  IconMenuUnfold,
  IconUser,
  IconUserGroup,
  IconCalendarClock,
  IconLiveBroadcast,
  IconThumbUp,
  IconArchive,
  IconPlayCircle,
  IconDesktop,
  IconRobot,
  IconShake,
  IconBook,
  IconCalendar,
  IconBytedanceColor,
  IconCommon,
  IconFile,
  IconGift,
  IconSettings,
  IconBulb,
  IconVideoCamera,
  IconFileVideo,
} from '@arco-design/web-react/icon';
import { useSelector } from 'react-redux';
import qs from 'query-string';
import NProgress from 'nprogress';
import Navbar from './components/NavBar';
import Footer from './components/Footer';
import useRoute, { IRoute } from '@/routes';
import useLocale from './utils/useLocale';
import getUrlParams from './utils/getUrlParams';
import lazyload from './utils/lazyload';
import { GlobalState } from './store';
import styles from './style/layout.module.less';
import routesData from './utils/routesData';
import axiosInstance from '@/utils/axiosInstance';
const role = localStorage.getItem?localStorage.getItem("role"):2;
const routesList = routesData(role);
const MenuItem = Menu.Item;
const SubMenu = Menu.SubMenu;
const Sider = Layout.Sider;
const Content = Layout.Content;
const systemType =  localStorage.getItem("systemType");

function getIconFromKey(key) {

  switch (key) {
    case 'dashboard':
      return <IconDashboard className={styles.icon} style={{marginRight:5}} />;
	case 'auto':
	    return <IconThumbUp className={styles.icon} style={{marginRight:5}} />;
	case 'short-video':
	return <IconLiveBroadcast  className={styles.icon} style={{marginRight:5}} />;
	case 'product-card':
	return <IconGift className={styles.icon} style={{marginRight:5}} />;
	case 'short-video/video-list/video-list':
	return <IconPlayCircle  className={styles.icon} style={{marginRight:5}} />;
	case 'live':
	return <IconDesktop className={styles.icon} style={{marginRight:5}} />;
	case 'liveAuto':
	return <IconThumbUp className={styles.icon} style={{marginRight:5}} />;
	case 'live/data-analysis/data-analysis':
	return <IconRobot   className={styles.icon} style={{marginRight:5}} />;
	
	case 'troupe/supplier/supplier':
	return <IconUser className={styles.icon} style={{marginRight:5}} />;
	
	case 'troupe/supplier/supplier-goods':
	return <IconArchive className={styles.icon} style={{marginRight:5}} />;
	
	case 'order':
	return <IconArchive  className={styles.icon} style={{marginRight:5}} />;
	
	case 'management/video-account':
	return <IconUser className={styles.icon} style={{marginRight:5}} />;
	
	case 'management/log':
	return <IconCalendarClock className={styles.icon} style={{marginRight:5}} />;
	
	case 'group':
	return <IconUserGroup className={styles.icon} style={{marginRight:5}} />;
	
	case 'dashboard1':
	return <IconDashboard className={styles.icon} style={{marginRight:5}} />;
	
    case 'example':
    return <IconTag className={styles.icon} style={{marginRight:5}} />;
	
	case 'lever':
	return <IconShake className={styles.icon} style={{marginRight:5}} />;
	case 'videoLever':
	return <IconShake className={styles.icon} style={{marginRight:5}} />;
	case 'fund':
	return <IconBook className={styles.icon} style={{marginRight:5}} />;
	case 'report':
	return <IconCalendar className={styles.icon} style={{marginRight:5}} />;
	case 'liveReport':
	return <IconCalendar className={styles.icon} style={{marginRight:5}} />;
	case 'promoteLive':
	return <IconCalendarClock className={styles.icon} style={{marginRight:5}} />;
	case 'longTermPlan':
	return <IconCalendarClock className={styles.icon} style={{marginRight:5}} />;
	case 'short-video/video-screen/video-screen':
	return <IconBytedanceColor  className={styles.icon} style={{marginRight:5}} />;
	case 'product-card/video-screen/video-screen':
	return <IconBytedanceColor  className={styles.icon} style={{marginRight:5}} />;
	case 'productCardReport':
	return <IconCalendar className={styles.icon} style={{marginRight:5}} />;
	case 'productCardAuto':
	return <IconThumbUp className={styles.icon} style={{marginRight:5}} />;
	case 'live/screen/screen':
	return <IconBytedanceColor  className={styles.icon} style={{marginRight:5}} />;
	case 'shop/shop-screen/shop-screen':
	return <IconBytedanceColor  className={styles.icon} style={{marginRight:5}} />;
	case 'shop/shop':
	return <IconCommon  className={styles.icon} style={{marginRight:5}} />;
	case 'shopManagement':
	return <IconFile  className={styles.icon} style={{marginRight:5}} />;
	case 'shopAfterSale':
	return <IconArchive  className={styles.icon} style={{marginRight:5}} />;
	
	case 'shopGoodsManagement':
	return <IconGift  className={styles.icon} style={{marginRight:5}} />;
	case 'shop/shop-management':
	return <IconSettings  className={styles.icon} style={{marginRight:5}} />;
	case 'shop/burst-order':
	return <IconBulb  className={styles.icon} style={{marginRight:5}} />;
	case 'vshopPromotionShop':
	return <IconVideoCamera  className={styles.icon} style={{marginRight:5}} />;
	case 'vshopPromotionLive':
	return <IconLiveBroadcast className={styles.icon} style={{marginRight:5}} />;
	case 'vhop/aide/auth':
	return <IconUser className={styles.icon} style={{marginRight:5}} />;
	case 'batchCreatePlan':
	return <IconFileVideo  className={styles.icon} style={{marginRight:5}} />;
	case 'shortAide':
	return <IconVideoCamera  className={styles.icon} style={{marginRight:5}} />;
	case 'assistant':
	return <IconLiveBroadcast  className={styles.icon} style={{marginRight:5}} />;
    default:
      return <div className={styles['icon-empty']} style={{marginRight:-8}} />;
  }
}

function getFlattenRoutes(routes) {

  const res = [];
  function travel(_routes) {
    _routes.forEach((route) => {
      const visibleChildren = (route.children || []).filter(
        (child) => !child.ignore
      );
      if (route.key && (!route.children || !visibleChildren.length)) {
        try {
          route.component = lazyload(() => import(`./pages/${route.key}`));
          res.push(route);
        } catch (e) {
          console.error(e);
        }
      }
      if (route.children && route.children.length) {
        travel(route.children);
      }
    });
  }
  travel(routes);
  return res;
}

function PageLayout() {
  const urlParams = getUrlParams();
  const history = useHistory();
  const pathname = history.location.pathname;

  const currentComponent = qs.parseUrl(pathname).url.slice(1);
  const locale = useLocale();
  const { settings, userLoading, userInfo } = useSelector(
    (state: GlobalState) => state
  );

  const [routes1, defaultRoute] = useRoute(userInfo?.permissions);
  
  // const menuK = Number(localStorage.getItem("menuKey")) >=routesList.length?0:Number(localStorage.getItem("menuKey"));
	const menuK = findRoute(routesList);
	const routes = routesList[menuK] || [];
	const menushow = routes.length==0?false:true;
	const defaultSelectedKeys = [currentComponent || defaultRoute];
	const paths = (currentComponent || defaultRoute).split('/');
	const defaultOpenKeys = paths.slice(0, paths.length - 1);
	const [breadcrumb, setBreadCrumb] = useState([]);
	const [collapsed, setCollapsed] = useState<boolean>(false);
	const [selectedKeys, setSelectedKeys] = useState<string[]>(defaultSelectedKeys);
	const localwebLogo = localStorage.getItem("localwebLogo")
	const [webLogo,setwebLogo] = useState(localwebLogo?localwebLogo:'');
	
	const [kfimg,setkfimg] = useState('');
	const [systemNotice,setsystemNotice] = useState('');
	const [miniprogramQrcode,setminiprogramQrcode] = useState('');
	const [openKeys, setOpenKeys] = useState<string[]>(defaultOpenKeys);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const windowsRef = useRef<any>(null);
	const routeMap = useRef<Map<string, React.ReactNode[]>>(new Map());
	const menuMap = useRef<
	Map<string, { menuItem?: boolean; subMenu?: boolean }>
	>(new Map());
	const navbarHeight = 60;
	const menuWidth = collapsed ? 48 : settings.menuWidth;
	const [aliCaptchaPrefix,setaliCaptchaPrefix] = useState('')
	const [aliCaptchaSceneIdWeb,setaliCaptchaSceneIdWeb] = useState('')
	function config() {
	  axiosInstance.get('/system/config')
	    .then((res) => {
	
	      if (res.data.code === 0) {
				setwebLogo(res.data.data.web_logo);
				localStorage.setItem("localwebLogo",res.data.data.web_logo)

				setkfimg(res.data.data.custom_qrcode_url)
				setsystemNotice(res.data.data.system_notice)
				localStorage.setItem("customQrcodeUrl",res.data.data.custom_qrcode_url)
				setminiprogramQrcode(res.data.data.miniprogram_qrcode)
				setShouldUpdate(true);
				setaliCaptchaPrefix(res.data.data.ali_captcha_prefix);
				setaliCaptchaSceneIdWeb(res.data.data.ali_captcha_sceneId_web);

	      }
	  })
	}
	useEffect(()=>{
		  if(!shouldUpdate){
			  config()
		  }
	},[])
	
	
	let showLeft = true;
	let showTop = true;
	let showBottom = true;
	if(currentComponent=='price/price' || currentComponent=='price/priceab' ||currentComponent=='index/index'|| currentComponent=='price/pay' || currentComponent=='invite/invite'|| currentComponent=='invite/inviteab' || currentComponent=='shop/shop-add/shop-add-first' || currentComponent=='shop/shop-add/shop-add-second' ){
		showLeft = false;
	}
	
	
	if(currentComponent=='short-video/video-screen/video-screen'){
		showTop = false;
		showLeft = false;
		showBottom =false;
	}
	if(currentComponent=='product-card/video-screen/video-screen'){
		showTop = false;
		showLeft = false;
		showBottom =false;
	}
	if(currentComponent=='live/screen/screen'){
		showTop = false;
		showLeft = false;
		showBottom =false;
	}
	if(currentComponent=='shop/shop-screen/shop-screen'){
		showTop = false;
		showLeft = false;
		showBottom =false;
	}
	if(currentComponent=='live/assistant1/assistant-screen'){
		showTop = false;
		showLeft = false;
		showBottom =false;
	}
	
	
	
	const showNavbar = settings.navbar && urlParams.navbar !== false && showTop;
	let showMenu = settings.menu && urlParams.menu !== false && showLeft;
	

	
	const showFooter = settings.footer && urlParams.footer !== false && showBottom;
	const flattenRoutes = useMemo(() => getFlattenRoutes(routes) || [], [routes]);

	
	function findRoute(routesList) {
		let routerIndex = 0;
		routesList.map((route,index) => {
			route.map((item1,index1)=>{
				if (location.pathname.includes(item1.key)) {
					routerIndex = index;
				}
				if (Array.isArray(item1.children)) {
					item1.children.map((item2,index2)=>{
						if (location.pathname.includes(item2.key)) {
							routerIndex = index;
						}
					})
				}
			})
	    })
		return routerIndex;
	}
  // 侧边栏需要展示 NEW 小标的菜单 key（短视频「长期计划」）
  const NEW_MENU_KEYS = ['longTermPlan'];
  function renderRoutes(locale) {
    routeMap.current.clear();
    return function travel(_routes: IRoute[], level, parentNode = []) {
		// console.log('route',_routes);
      return _routes.map((route) => {
		  
		  
        const { breadcrumb = true, ignore } = route;
        const iconDom = getIconFromKey(route.key);
		const large = iconDom.props.isIcon!=undefined?{fontWeight:'bold'}:{fontWeight:'400'};
		if(route.key=='shopAdd' || route.key=='live/assistant1/assistant-screen' || route.key=='vhop/launch-data/promotion-shop-detail' || route.key=='vhop/launch-data/promotion-live-detail' || route.key=='vhop/launch-data/createPromoteForm' || route.key=='vhop/launch-data/live-promote-order-detail'){
			return '';
		}
        const titleDom = (
			// (route.key=='live/promote-plan/launch-data/launch-data') ? (
			// 	<>
			// 	{iconDom} <span style={large}>{locale[route.name] || route.name}</span> <div style={{position:'absolute',top:0,left:105,fontSize:10,background:'red',color:'#FFFFFF',width:30,height:15,borderRadius:20,textAlign:'center',lineHeight:'15px',padding:'0 2px 0 2px'}}>内测</div>
			// 	</>
			// ):(
				// (route.key=='short-video/batch-create-plan/batch-create-plan') ? (
				// 	<>
				// 	{iconDom} <span style={large}>{locale[route.name] || route.name}</span> <div style={{position:'absolute',top:0,left:105,fontSize:10,background:'red',color:'#FFFFFF',width:30,height:15,borderRadius:20,textAlign:'center',lineHeight:'15px',padding:'0 2px 0 2px'}}>内测</div>
				// 	</>
				// ):(
					<>
					{iconDom} <span style={large} className={styles['menu-title']}>
						{locale[route.name] || route.name}
						{NEW_MENU_KEYS.includes(route.key) && <span className={styles['new-tag']}>NEW</span>}
					</span>
					</>
				// )
			// )
          
		  
        )

        routeMap.current.set(
          `/${route.key}`,
          breadcrumb ? [...parentNode, route.name] : []
        );

        const visibleChildren = (route.children || []).filter((child) => {
          const { ignore, breadcrumb = true } = child;
          if (ignore || route.ignore) {
            routeMap.current.set(
              `/${child.key}`,
              breadcrumb ? [...parentNode, route.name, child.name] : []
            );
          }
          return !ignore;
        });

        if (ignore) {
          return '';
        }

        if (visibleChildren.length) {
          menuMap.current.set(route.key, { subMenu: true });
          return (
            <SubMenu   key={route.key} title={titleDom}>
              {travel(visibleChildren, level + 1, [...parentNode, route.name])}
            </SubMenu>
          );
        }
        menuMap.current.set(route.key, { menuItem: true });
        return <MenuItem  key={route.key}>{titleDom}</MenuItem>;
      });
    };
  }

  function onClickMenuItem(key) {
	  if(key=='short-video/video-screen/video-screen'){
		const url = '/home/short-video/video-screen/video-screen';
		if(windowsRef.current==null){
			const windows = window.open('/home/short-video/video-screen/video-screen', "_blank");
			windowsRef.current = windows
			localStorage.setItem('videoScreenOpen', '1');
		}else{
			const videoScreenOpen = localStorage.getItem('videoScreenOpen');
			if(videoScreenOpen=='1'){
				windowsRef.current.focus();
			}else{
				const windows = window.open('/home/short-video/video-screen/video-screen', "_blank");
				windowsRef.current = windows
				localStorage.setItem('videoScreenOpen', '1');
			}
		}
	  }else if(key=='product-card/video-screen/video-screen'){
		if(windowsRef.current==null){
			const windows = window.open('/home/product-card/video-screen/video-screen', "_blank");
			windowsRef.current = windows
			localStorage.setItem('ecshopScreenOpen', '1');
		}else{
			const ecshopScreenOpen = localStorage.getItem('ecshopScreenOpen');
			if(ecshopScreenOpen=='1'){
				windowsRef.current.focus();
			}else{
				const windows = window.open('/home/product-card/video-screen/video-screen', "_blank");
				windowsRef.current = windows
				localStorage.setItem('ecshopScreenOpen', '1');
			}
		}
	  }else if(key=='live/screen/screen'){
		if(windowsRef.current==null){
			const windows = window.open('/home/live/screen/screen', "_blank");
			windowsRef.current = windows
			localStorage.setItem('screenOpen', '1');
		}else{
			const videoScreenOpen = localStorage.getItem('screenOpen');
			if(videoScreenOpen=='1'){
				windowsRef.current.focus();
			}else{
				const windows = window.open('/home/live/screen/screen', "_blank");
				windowsRef.current = windows
				localStorage.setItem('screenOpen', '1');
			}
		}
	  }else if(key=='shop/shop-screen/shop-screen'){
		if(windowsRef.current==null){
			const windows = window.open('/home/shop/shop-screen/shop-screen', "_blank");
			windowsRef.current = windows
			localStorage.setItem('shopScreenOpen', '1');
		}else{
			const shopScreenOpen = localStorage.getItem('shopScreenOpen');
			if(shopScreenOpen=='1'){
				windowsRef.current.focus();
			}else{
				const windows = window.open('/home/shop/shop-screen/shop-screen', "_blank");
				windowsRef.current = windows
				localStorage.setItem('shopScreenOpen', '1');
			}
		}
	  }else if(key=='live/assistant1/assistant-screen'){
		if(windowsRef.current==null){
			const windows = window.open('/home/live/assistant1/assistant-screen', "_blank");
			windowsRef.current = windows
			localStorage.setItem('assistantScreenOpen', '1');
		}else{
			const assistantScreenOpen = localStorage.getItem('assistantScreenOpen');
			if(assistantScreenOpen=='1'){
				windowsRef.current.focus();
			}else{
				const windows = window.open('/home/live/assistant1/assistant-screen', "_blank");
				windowsRef.current = windows
				localStorage.setItem('assistantScreenOpen', '1');
			}
		}
	  }else{
		  const currentRoute = flattenRoutes.find((r) => r.key === key);
		  const component = currentRoute.component;
		  const preload = component.preload();
		  NProgress.start();
		  preload.then(() => {
		    history.push(currentRoute.path ? currentRoute.path : `/${key}`);
		    NProgress.done();
		  });
		  
	  }
	 

  }

	function toggleCollapse() {
		setCollapsed((collapsed) => !collapsed);
	}
	function instructions(){
		let url = ''
		if(Number(systemType)==2){
			url = 'http://6-w.cn/hCWZ'
		}else{
			url = 'https://wwzxnqwscdk.feishu.cn/wiki/BHMJwms4wigYwqkFL5Wc0WXInMh?from=from_copylink'
		}
		
		window.open(url, '_blank');
	}
	function instructions1(){
		let url = ''
		if(Number(systemType)==2){
			url = 'https://space.bilibili.com/3546818654767552'
		}else{
			url = ''
		}
		
		window.open(url, '_blank');
	}
	// const noShowlink=[
	// 	'price/price',
	// 	'index/index'
	// ];
	
	
	// if(routes[0]['key'] == 'short-video/video-screen/video-screen'){
	// 	const newWindow = window.open("", "_top");
	// 	      newWindow.document.write('short-video/video-screen/video-screen');
	// 	      newWindow.focus();
	// }

  if(!menushow){
	  showMenu=false
  }
  const paddingLeft = showMenu ? { paddingLeft: menuWidth } : {};
  const paddingTop = showNavbar ? { paddingTop: navbarHeight } : {};
  const paddingStyle = { ...paddingLeft, ...paddingTop };
  // const menus =  menushow? {display:'block'}:{display:'none'};
  // paddingTop = {...paddingTop,...menus};
  function updateMenuStatus() {

    const pathKeys = pathname.split('/');
    const newSelectedKeys: string[] = [];
    const newOpenKeys: string[] = [...openKeys];
    
    // 特殊处理：当访问详情页面时，选中对应的数据页面
    const currentPath = pathname.replace(/^\//, '');
    if (currentPath === 'vhop/launch-data/promotion-shop-detail') {
      // 详情页面时选中推广数据菜单
      newSelectedKeys.push('vhop/launch-data/promotion-shop');
      // 确保父级菜单展开
      if (!openKeys.includes('vshopPromotion')) {
        newOpenKeys.push('vshopPromotionShop');
      }
    }else if (currentPath === 'vhop/launch-data/promotion-live-detail') {
      // 详情页面时选中推广数据菜单
      newSelectedKeys.push('vhop/launch-data/promotion-live');
      // 确保父级菜单展开
      if (!openKeys.includes('vshopPromotionLive')) {
        newOpenKeys.push('vshopPromotionLive');
      }
    }else if(currentPath === 'vhop/launch-data/createPromoteForm'){
		newSelectedKeys.push('vhop/launch-data/promotion-live');
      // 确保父级菜单展开
      if (!openKeys.includes('vshopPromotionLive')) {
        newOpenKeys.push('vshopPromotionLive');
      }
	}else if(currentPath === 'vhop/launch-data/live-promote-order-detail'){
		newSelectedKeys.push('vhop/launch-data/promotion-live');
      // 确保父级菜单展开
      if (!openKeys.includes('vshopPromotionLive')) {
        newOpenKeys.push('vshopPromotionLive');
      }
	}else {
      // 正常的菜单选中逻辑
      while (pathKeys.length > 0) {
        const currentRouteKey = pathKeys.join('/');
        const menuKey = currentRouteKey.replace(/^\//, '');
        const menuType = menuMap.current.get(menuKey);
        if (menuType && menuType.menuItem) {
          newSelectedKeys.push(menuKey);
        }
        if (menuType && menuType.subMenu && !openKeys.includes(menuKey)) {
          newOpenKeys.push(menuKey);
        }
        pathKeys.pop();
      }
    }
    
    setSelectedKeys(newSelectedKeys);
    setOpenKeys(newOpenKeys);
  }
	
  useEffect(() => {
    const routeConfig = routeMap.current.get(pathname);
    setBreadCrumb(routeConfig || []);
    updateMenuStatus();
  }, [pathname]);
  return (
    <Layout className={styles.layout}>
      <div
        className={cs(styles['layout-navbar'], {
          [styles['layout-navbar-hidden']]: !showNavbar,
        })}
      >
        <Navbar  show={showNavbar} webLogo={webLogo} kfimg={kfimg} systemNotice={systemNotice} miniprogramQrcode={miniprogramQrcode} aliCaptchaPrefix={aliCaptchaPrefix} aliCaptchaSceneIdWeb={aliCaptchaSceneIdWeb} />
      </div>
      {userLoading ? (
        <Spin className={styles['spin']} />
      ) : (
        <Layout>
          {showMenu && (
            <Sider
              className={styles['layout-sider']}
              width={menuWidth}
              collapsed={collapsed}
              onCollapse={setCollapsed}
              trigger={null}
              collapsible
              breakpoint="xl"
              style={paddingTop}
			
            >
              <div className={styles['menu-wrapper']} >
                <Menu
                  collapse={collapsed}
                  onClickMenuItem={onClickMenuItem}
                  selectedKeys={selectedKeys}
                  // openKeys={openKeys}
				  autoOpen={true}
                  // onClickSubMenu={(_, openKeys) => setOpenKeys(openKeys)}
                >
                  {renderRoutes(locale)(routes, 1)}
                </Menu>
              </div>
				{Number(systemType) == 1?(
					<>
					{collapsed ? (
						<></>
					) : (
						
						<div>
							{/*<div  className={styles['collapse-div1']} onClick={instructions}>
									视频教程
							</div>*/}
							<div  className={styles['collapse-div']} onClick={instructions}>
									操作手册
							</div>
						</div>
					)}
					</>
					
					
				):(
					<>
					{collapsed ? (
						<></>
					) : (
						<div>
							{/*<div  className={styles['collapse-div1']} onClick={instructions1}>
									视频教程
							</div>*/}
							<div  className={styles['collapse-div']} onClick={instructions}>
									操作手册
							</div>
						</div>
					)}
					</>
				)}
			
				
			  
              <div className={styles['collapse-btn']} onClick={toggleCollapse}>
                {collapsed ? <IconMenuUnfold /> : <IconMenuFold />}
              </div>
            </Sider>
          )}
          <Layout className={(currentComponent=='short-video/video-screen/video-screen' || currentComponent=='product-card/video-screen/video-screen')?'':styles['layout-content']} style={paddingStyle}>
            <div className={styles['layout-content-wrapper']}>
			{/*  
              {!!breadcrumb.length && (
                <div className={styles['layout-breadcrumb']}>
                  <Breadcrumb>
                    {breadcrumb.map((node, index) => (
                      <Breadcrumb.Item key={index}>
                        {typeof node === 'string' ? locale[node] || node : node}
                      </Breadcrumb.Item>
                    ))}
                  </Breadcrumb>
                </div>
              )}
			*/}
              <Content>
                <Switch>
                  {flattenRoutes.map((route, index) => {
                    return (
                      <Route
                        key={index}
                        path={`/${route.key}`}
                        component={route.component}
                      />
                    );
                  })}
                  <Route exact path="/">
                    <Redirect to={`/${defaultRoute}`} />
                  </Route>
                  <Route
                    path="*"
                     component={lazyload(() => import('./pages/exception/403'))}
					
					//component={lazyload(() => import('./pages/short-video/launch-data/launch-data'))}
					
                  />
				  
                </Switch>
              </Content>
            </div>
            {showFooter && <Footer />}
          </Layout>
        </Layout>
      )}
    </Layout>
  );
}

export default PageLayout;
